module.exports = __webpack_public_path__ + "img/southwest-summer-1920x550.832165c4.jpg";